import Vue from "vue";
import App from "./App.vue";
import "@/assets/css/application.scss";
import store from "./store";

// Toast
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
  // You can set your default options here
  position: "bottom-right",
  timeout: 4476,
  hideProgressBar: true,
};

Vue.use(Toast, options);

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
